import findInboxInHistory from './find_inbox_in_history';
import Inbox from 'models/location/inbox';

export default function(context) {
  let currentLocation = context.stores.currentLocation.get();
  return (currentLocation instanceof Inbox && currentLocation) || findInboxInHistory(context) || Inbox.create();
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/inbox/lib/get_last_inbox_location.js